import { render, staticRenderFns } from "./AdminPasswordByKey.vue?vue&type=template&id=4518fcc0&scoped=true&"
import script from "./AdminPasswordByKey.vue?vue&type=script&lang=ts&"
export * from "./AdminPasswordByKey.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPasswordByKey.vue?vue&type=style&index=0&id=4518fcc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518fcc0",
  null
  
)

export default component.exports